export default "__VITE_ASSET__6bd7c689__"